import classNames from "classnames";
import React, { useCallback } from "react";
import { Trans } from "react-i18next";
import { Link } from "react-router-dom";
import Profile from "components/left/Profile";


const SettingMenu = (props) => {

    const getActive = useCallback((url) => {
        const { pathname } = props;
        return url === pathname ? "on" : null;
    },[props]);

    const { stationInfo } = props;
    const { data = {} } = stationInfo;
    const { station, is_partner_bj, is_best_bj, profile_image, is_owner = false, is_manager = false } = data;
    const { match } = props;
    const lang = document.documentElement.lang;

    return (
        <div id="bs-navi" className="">
            <div className="bs-navi_contents">
                <Profile
                    id = {match.params.id}
                    path = {match.path}
                    match={match}
                    station={station}
                    is_partner_bj={is_partner_bj}
                    is_best_bj={is_best_bj}
                    profile_image={profile_image}
                />
                {is_owner && (
                    <section className="menu-list a1">
                        <h3>
                            <span>
                                <Trans>Quản lý Blog</Trans>
                            </span>
                        </h3>
                        <ul>
                            <li className={classNames(getActive(`${match.url}/basic`))}>
                                <Link to={`${match.url}/basic`}>
                                    <Trans>Quản lý thông tin Blog</Trans>
                                </Link>
                            </li>
                            <li className={classNames(getActive(`${match.url}/title`))}>
                                <Link to={`${match.url}/title`}>
                                    <Trans>Quản lý hình ảnh tiêu đề</Trans>
                                </Link>
                            </li>
                            <li className={classNames(getActive(`${match.url}/link`))}>
                                <Link to={`${match.url}/link`}>
                                    <Trans>Quản lý liên kết ngoài</Trans>
                                </Link>
                            </li>
                            <li className={classNames(getActive(`${match.url}/banner`))}>
                                <Link to={`${match.url}/banner`}>
                                    <Trans>Quản lý banner</Trans>
                                </Link>
                            </li>
                            <li className={classNames(getActive(`${match.url}/board`))}>
                                <Link to={`${match.url}/board`}>
                                    <Trans>Quản lý bảng tin</Trans>
                                </Link>
                            </li>
                            <li className={classNames(getActive(`${match.url}/banword`))}>
                                <Link to={`${match.url}/banword`}>
                                    <Trans>Quản lý từ cấm</Trans>
                                </Link>
                            </li>
                        </ul>
                    </section>
                )}
                {is_manager && (
                    <section className="menu-list a1">
                        <h3>
                            <span>
                                <Trans>Quản lý Blog</Trans>
                            </span>
                        </h3>
                        <ul>
                            <li className={classNames(getActive(`${match.url}/banword`))}>
                                <Link to={`${match.url}/banword`}>
                                    <Trans>Quản lý từ cấm</Trans>
                                </Link>
                            </li>
                        </ul>
                    </section>
                )}
                {is_owner && (
                    <section className="menu-list a2">
                        <h3>
                            <span>
                                <Trans>Quản lý quyền và người dùng</Trans>
                            </span>
                        </h3>
                        <ul>
                            <li className={classNames(getActive(`${match.url}/fanclub`))}>
                                <Link to={`${match.url}/fanclub`}>
                                    <Trans>Quản lý Fan Club/Quản trị viên</Trans>
                                </Link>
                            </li>
                            <li
                                className={classNames(
                                    getActive(`${match.url}/subscription`),
                                    getActive(`${match.url}/supporter`),
                                )}
                            >
                                <Link to={`${match.url}/subscription`}>
                                    <Trans>Quản lý người đăng ký/ủng hộ</Trans>
                                </Link>
                            </li>
                            <li
                                className={classNames(getActive(`${match.url}/vodauth`), getActive(`${match.url}/vodreject`))}
                            >
                                <Link to={`${match.url}/vodauth`}>
                                    <Trans>Quản lý quyền VOD</Trans>
                                </Link>
                            </li>
                            {/* <li className={classNames(getActive(`${match.url}/editor`))}>
                                <Link to={`${match.url}/editor`}>
                                    <Trans>Chỉnh sửa quyền quản lý</Trans>
                                </Link>
                            </li> */}
                            <li className={classNames(getActive(`${match.url}/blacklist`))}>
                                <Link to={`${match.url}/blacklist`}>
                                    <Trans>Quản lý danh sách đen</Trans>
                                </Link>
                            </li>
                            <li className={classNames(getActive(`${match.url}/userclip-blacklist`))}>
                                <Link to={`${match.url}/userclip-blacklist`}>
                                    <Trans>Quản lý Clip/Short</Trans>
                                </Link>
                            </li>
                        </ul>
                    </section>
                )}
                {is_manager && (
                    <section className="menu-list a2">
                        <h3>
                            <span>
                                <Trans>Quản lý quyền và người dùng</Trans>
                            </span>
                        </h3>
                        <ul>
                            <li className={classNames(getActive(`${match.url}/blacklist`))}>
                                <Link to={`${match.url}/blacklist`}>
                                    <Trans>Quản lý danh sách đen</Trans>
                                </Link>
                            </li>
                        </ul>
                    </section>
                )}
                {is_owner && (
                    <section className="menu-list a3">
                        <h3>
                            <span>
                                <Trans>Quản lý thông tin cá nhân</Trans>
                            </span>
                        </h3>
                        <ul>
                            <li className={classNames(getActive(`${match.url}/info`))}>
                                <Link to={`${match.url}/info`}>
                                    <Trans>Quản lý thông tin cá nhân</Trans>
                                </Link>
                            </li>
                            <li className={classNames(getActive(`${match.url}/profile`))}>
                                <Link to={`${match.url}/profile`}>
                                    <Trans>Quản lý thông tin tìm kiếm</Trans>
                                </Link>
                            </li>
                        </ul>
                    </section>
                )}
            </div>
        </div>
    );
}

export default SettingMenu;